import BlueDotsBackground from '../../BlueDotsBackground';
import people from '../../content/people';

export default function AmplifyingPharmaTechInvestments() {
  return (
    <>
      <BlueDotsBackground />

      <section id="header" className="text-white px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <header className="text-left">
            <h1 className="text-4xl font-bold text-white">
              Amplifying Pharma Technology Investments
            </h1>

            <div className="mt-4 flex items-center justify-start gap-4">
              <div className="text-sm text-gray-400">
                <p>10/04/2026</p>
                <p>By Eduardo Goncalves, Founder and CEO, Kernel</p>
              </div>
              <img
                src={people[0].image}
                alt={people[0].name}
                className="w-10 h-10 rounded-full object-cover border-2 border-white/30 shadow-md"
              />
            </div>
          </header>
        </div>
      </section>

      {/* Article Section */}
      <section id="article" className="text-white px-6 py-4">
        <div className="flex items-center justify-center min-h-screen">
          <div className="mb-24 max-w-2xl px-4 text-left">
            <p className="text-sm text-gray-300">
              The pharmaceutical industry has made significant investments in
              revenue management technology over the last decade. Large
              manufacturers have committed tens and sometimes hundreds of
              millions of dollars to platforms such as Model N, while also
              funding the integrations, data migration efforts, governance
              programs, and organizational changes required to support these
              implementations. These investments are both necessary and
              strategic. Enterprise platforms provide critical process
              standardization, scalability, and system-of-record capabilities
              that support some of the industry's most complex commercial and
              government pricing operations. Yet, despite these substantial
              investments, many organizations continue to face operational
              challenges that extend beyond the core capabilities of any single
              platform.
              <br />
              <br />
              No enterprise software platform, regardless of how capable, can
              address every operational requirement of every customer. Large
              vendors must balance scalability, standardization, regulatory
              demands, and the needs of a broad customer base. As business
              processes evolve, gaps inevitably emerge around workflow
              automation, exception management, compliance oversight, and
              operational visibility. These gaps are not signs of platform
              weakness; they are a natural consequence of complex organizations
              operating in a rapidly changing business and regulatory
              environment.
              <br />
              <br />
              Kernel was built to complement, not replace, existing enterprise
              investments. Today, Kernel operates alongside Model N in multiple
              large pharmaceutical organizations, helping automate and
              streamline processes across Master Data, Sales &amp; Concessions,
              Government Pricing, and Gross-to-Net. By addressing workflow,
              compliance, and operational visibility gaps around the core
              platform, Kernel enables organizations to accelerate improvements
              without disrupting their underlying Model N environment. In many
              cases, Kernel becomes the operational layer that connects teams,
              automates manual activities, enforces controls, and provides
              transparency across end-to-end business processes while preserving
              the integrity of the enterprise system of record.
              <br />
              <br />
              This complementary approach has proven particularly valuable
              because it allows organizations to generate business value without
              undertaking another large-scale transformation project. Rather
              than replacing existing technology, pharmaceutical companies can
              leverage Kernel modules to strengthen processes that already
              depend on Model N. As enterprise environments become more complex
              and compliance expectations continue to rise, organizations
              increasingly need solutions that can be deployed quickly,
              configured rapidly, and adapted to changing business requirements.
              Kernel's focused product modules allow companies to address
              specific operational challenges while maximizing the returns on
              their existing technology investments.
              <br />
              <br />
              The most successful technology strategies are rarely about
              replacing existing systems; they are about maximizing the value of
              investments already made. Kernel represents a focused, lower-risk
              investment that sits on top of enterprise platforms and unlocks
              additional business value. By combining the stability and scale of
              Model N with the agility and innovation of Kernel, pharmaceutical
              companies can achieve outcomes where the combined result is
              greater than either solution could deliver independently: a true
              example of 1 + 1 &gt; 2. In an environment where both technology
              budgets and business expectations are under constant pressure, the
              ability to amplify existing investments may be one of the most
              effective strategies available to pharmaceutical leaders.
              <br />
              <br />
              <span className="italic text-gray-400">
                Eduardo Goncalves is the Founder and CEO of Kernel. He works
                with pharmaceutical manufacturers to simplify complex revenue
                management operations through practical innovation, workflow
                automation, and technology solutions that complement existing
                enterprise investments.
              </span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
